import React from "react";
import { useSelector } from "react-redux";
import { Button, Dropdown, Flex } from "antd";
import type { MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalOutlined } from "@ant-design/icons";
import { makeSelectLanguage } from "../../../containers/App/selectors";
import { SupportedLanguages } from "../../../viewModels/Settings/TranslationModel";

export const supportedLanguages: Array<SupportedLanguages> = ["zh", "ru", "en"];
export const languageLabels: Record<SupportedLanguages, string> = {
  zh: "简体中文",
  en: "English",
  ru: "Русский",
};
export const languageIcons: Record<SupportedLanguages, string> = {
  zh: "🇨🇳",
  ru: "🇷🇺",
  en: "🇬🇧",
};

export const getLanguageMenuLabel = (language: SupportedLanguages) => (
  <Flex align="center" gap={8}>
    <span aria-hidden>{languageIcons[language]}</span>
    <span>{languageLabels[language]}</span>
  </Flex>
);

const LanguageSelector = React.memo(() => {
  const { i18n } = useTranslation();

  const language = useSelector(makeSelectLanguage());

  const handleChangeLanguage = React.useCallback(
    (value: SupportedLanguages) => {
      i18n.changeLanguage(value);
    },
    [i18n],
  );

  const items: MenuProps["items"] = supportedLanguages.map((x) => ({
    key: x,
    label: getLanguageMenuLabel(x),
    onClick: () => handleChangeLanguage(x),
  }));

  return (
    <Dropdown menu={{ items, selectedKeys: [language] }} placement="bottomRight">
      <Button aria-label={languageLabels[language]} icon={<GlobalOutlined />} type="text" />
    </Dropdown>
  );
});

export default LanguageSelector;
